const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

export const resolveSocketUrl = () => {
  const envUrl = (process.env.REACT_APP_SOCKET_URL || '').trim();
  const defaultPort = process.env.REACT_APP_SOCKET_PORT || '5006';

  if (typeof window === 'undefined') {
    return envUrl || `http://localhost:${defaultPort}`;
  }

  const browserHost = window.location.hostname;
  const browserProtocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
  const browserIsLocal = LOCAL_HOSTNAMES.has(browserHost);

  if (envUrl) {
    try {
      const parsed = new URL(envUrl);
      if (!browserIsLocal && LOCAL_HOSTNAMES.has(parsed.hostname)) {
        parsed.hostname = browserHost;
      }
      if (!parsed.port) {
        parsed.port = defaultPort;
      }
      return parsed.origin;
    } catch (_) {
      return envUrl;
    }
  }

  if (!browserIsLocal) {
    return window.location.origin;
  }

  return `${browserProtocol}//${browserHost}:${defaultPort}`;
};
